import { createAction } from '@ngrx/store';

export const resetState = createAction('RESET_STATE');
